<div class="grid-cont grid-cont--xs">
  <h1>Account Settings</h1>

  <div class="mt--100 block account-settings">
    <h4>User Information</h4>

    <form name="registerForm" [formGroup]="accountSettingsForm" novalidate>
      <div class="settings-container w-100">
        <!-- Display name chonk -->
        <label class="mt--100">
          Display Name
          <input readonly type="text" value="" name="userDisplayName" class="mt--025 form-input" formControlName="userDisplayName">
        </label>

        <!-- Email chonk -->
        <label class="mt--100">
          Email Address
          <input readonly type="text" value="" name="userEmailAddress" class="mt--025 form-input" formControlName="userEmailAddress">
        </label>

        <!-- Password chonk -->
        <div  class="d-flex flex-column">
          <label class="d-flex flex-row justify-content-between align-items-center">
            <div>
              Password
            </div>

            <button andButton color="ghost-secondary" (click)="changePassword()" type="button" size="small">Change</button>
          </label>

          <input disabled type="password" value="{{password}}" name="userPassword" class="mt--025 form-input" formControlName="userPassword">
        </div>

        <!-- MFA chonk -->
        @if (displayMfaSettings()) {

          @let mfaPhone = user()?.getMfaPhone();
          @if (user()?.hasEnrolledInMfa() && mfaPhone) {
            <div  class="d-flex flex-column">
              <label class="d-flex flex-row justify-content-between align-items-center">
                <div>
                  2-step verification
                </div>

                <button andButton color="ghost-secondary" (click)="showMfaEnrollmentDialog()" type="button" size="small" [isLoading]="processingMfaUpdate()">Edit</button>
              </label>

              <input
                disabled
                type="tel"
                value="***-***-{{ mfaPhone | slice: mfaPhone.length - 4 : mfaPhone.length }}"
                class="mt--025 form-input"
              >
            </div>
          } @else {
            <button andButton color="secondary" type="button" class="align-self-end" (click)="showMfaEnrollmentDialog()" [isLoading]="processingMfaUpdate()">
              Set up 2-step verification
            </button>

            <div class="alert alert--error">
              Not using 2-step verification makes your account less secure and is not recommended.
            </div>
          }
        }
      </div>
    </form>
  </div>

  <app-client-portal-footer class="mt-8"></app-client-portal-footer>
</div>
